import { onDomContentLoaded } from 'Functions/helpers';
import { buildStars } from 'Functions/rating';

import(/* webpackChunkName: "default-layout" */ "Layouts/default");

const indexProductTabs = document.querySelector('.js-index-product-tabs')

if (indexProductTabs) {
    indexProductTabs.addEventListener('rTab.after.openTab', (event) => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const slider = event.target.querySelector('r-slider')

                window.sliderLazyLoad.update()

                if (slider && slider.swiper) {
                    slider.swiper.update()

                    if (slider.swiper.params.cssMode) {
                        slider.swiper.wrapperEl.scrollTo(0, 0)
                    }
                }
            })
        })
    })
}

onDomContentLoaded(() => {
    buildStars();
});